import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { authService } from '@/api/services/management-key';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/cloud-access/cloud-management-keys',
)({
  beforeLoad: ({ params: { accountId } }) => ({
    managementKeysQuery: authService.listManagementKeysQuery({ accountId }),
  }),
  // Fetching the list runs the permissions interceptor, which throws an AccessControlError
  // (handled as a not-found) when the user lacks `read:management_keys`.
  loader: ({ context: { queryClient, managementKeysQuery } }) => queryClient.ensureQueryData(managementKeysQuery),
  component: lazyRouteComponent(() => import('@/components/Access/ManagementKeysList'), 'ManagementKeysComponent'),
  pendingMs: 200,
  pendingComponent: lazyRouteComponent(
    () => import('@/components/Access/ManagementKeysList'),
    'ManagementKeysPendingComponent',
  ),
});
